import { UserZone } from "./userZone.model";



export interface IProductDeliveryZones{
  id ?: number;
  userZone ?: UserZone;
  price ?: number;
}

export class ProductDeliveryZones implements IProductDeliveryZones{
  constructor(
    public id?: number,
    public userZone ?: UserZone,
    public price ?: number,
  ){
    this.id = id;
    this.userZone = userZone;
    this.price = price;
  }
}
